import type { TaxYearInput } from "../features/tax-planner/types/tax.types";
import type { UserPreferences } from "@boo/shared";
import { ApiError, request } from "./apiClient";

export async function fetchTaxYearData(
  year: number,
): Promise<TaxYearInput | null> {
  try {
    return await request<TaxYearInput>(`/tax-planner/${year}`);
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) return null;
    throw e;
  }
}

export async function saveTaxYearData(
  year: number,
  data: TaxYearInput,
): Promise<void> {
  await request(`/tax-planner/${year}`, {
    method: "PUT",
    data,
  });
}

export async function fetchUserPreferences(): Promise<UserPreferences | null> {
  try {
    return await request<UserPreferences>("/tax-planner/preferences");
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) return null;
    throw e;
  }
}

export async function saveUserPreferences(
  prefs: UserPreferences,
): Promise<void> {
  await request("/tax-planner/preferences", {
    method: "PUT",
    data: prefs,
  });
}
